import styled from 'styled-components';

export const StyledGrandDiv = styled.div`
  width: 100%;
  min-height: 4.5rem;
  height: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledText = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  user-select: none;
  width: 20%;
  color: #212326;
`;

export const InsideDiv = styled.div`
  margin-left: 2rem;
  margin-right: 2.21rem;
  width: 100%;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;
